import { render } from "./FormStep.vue?vue&type=template&id=9956f280&scoped=true"
import script from "./FormStep.vue?vue&type=script&lang=js"
export * from "./FormStep.vue?vue&type=script&lang=js"

import "./FormStep.vue?vue&type=style&index=0&id=9956f280&lang=css"
import "./FormStep.vue?vue&type=style&index=1&id=9956f280&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ma-dg\\Desktop\\wa\\ask_wizard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9956f280"]])

export default __exports__